module.exports = __webpack_public_path__ + "img/i-inst.41689fb3.svg";